import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { showAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { isCurrentAppointmentGrouped } from 'modules/appointmentInfo/selectors/currentAppointment';

import createAction from './index';
import { FETCH_APPOINTMENT } from './fetchAppointment';
import * as services from '../services/updateAppointmentGroupCurrentAppointment';
import { CLOSED_APPOINTMENT_STATUSES } from '../../common/constants/appointmentStatuses';


export const FETCH_GROUPED_APPOINTMENT = createAsyncAction(createAction('FETCH_GROUPED_APPOINTMENT'));

export const updateAppointmentGroupCurrentAppointment = appointmentId => dispatch => {
  dispatch({ type: FETCH_GROUPED_APPOINTMENT.pending });

  const apiCallParams = {
    mutation: services.UPDATE_APPOINTMENT_GROUP_CURRENT_APPOINTMENT,
    variables: { appointmentId },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(response => {
      const appointment = response.data.updateAppointmentGroupCurrentAppointment;
      const schedules = appointment.schedules.filter(({ status }) => status === 'CREATED');
      const tempAppt = { ...appointment, schedules };

      dispatch(showAppointmentInfo(appointment.appointmentId));
      dispatch({
        type: FETCH_APPOINTMENT.success,
        payload:
          {
            appointment: {
              ...appointment,
              schedules,
            },
          },
      });
      dispatch({ type: FETCH_GROUPED_APPOINTMENT.success, payload: { appointmentId: appointment.appointmentId } });


      return tempAppt;
    })
    .catch();
};

export const fetchFirstGroupedAppointment = () => (dispatch, getState) => {
  const state = getState();
  if (isCurrentAppointmentGrouped(state)) return;
  const { currentAppointment } = state.appointmentInfo;
  const isClosed = CLOSED_APPOINTMENT_STATUSES.includes(currentAppointment.status);

  const tempApptGroup = currentAppointment.group.appointments.filter(
    tempAppt => (isClosed
      ? CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status)
      : !CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status)) || tempAppt.appointmentId !== currentAppointment.appointmentId,
  );

  if (tempApptGroup.length) return dispatch(updateAppointmentGroupCurrentAppointment(tempApptGroup[0].appointmentId));
};
